<template>
  <div class="contentBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
      </div>
    </div>
    <div class="priBox min-w-1400" @click="toggleNewImage(1)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg1 ? yImgAct1 : yImg1" class="imgItem" />
      </div>
    </div>
    <div class="priBox min-w-1400" @click="toggleNewImage(2)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg2 ? yImgAct2 : yImg2" class="imgItem" />
      </div>
    </div>
    <div class="priBox min-w-1400" @click="toggleNewImage(3)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg3 ? yImgAct3 : yImg3" class="imgItem" />
      </div>
    </div>
    <div class="priBox min-w-1400" @click="toggleNewImage(4)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg4 ? yImgAct4 : yImg4" class="imgItem" />
      </div>
    </div>
    <div class="priBox min-w-1400" @click="toggleNewImage(5)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg5 ? yImgAct5 : yImg5" class="imgItem" />
      </div>
    </div>
    <div class="priBox min-w-1400" @click="toggleNewImage(6)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg6 ? yImgAct6 : yImg6" class="imgItem" />
      </div>
    </div>
    <div class="priBox min-w-1400" @click="toggleNewImage(7)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg7 ? yImgAct7 : yImg7" class="imgItem" />
      </div>
    </div>
    <div class="priBox min-w-1400" @click="toggleNewImage(8)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg8 ? yImgAct8 : yImg8" class="imgItem" />
      </div>
    </div>
    <div class="priBox min-w-1400" @click="toggleNewImage(9)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg9 ? yImgAct9 : yImg9" class="imgItem" />
      </div>
    </div>
    <div class="priBox min-w-1400" @click="toggleNewImage(10)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg10 ? yImgAct10 : yImg10" class="imgItem" />
      </div>
    </div>
    <div class="priBox min-w-1400" @click="toggleNewImage(11)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg11 ? yImgAct11 : yImg11" class="imgItem" />
      </div>
    </div>
    <div class="priBox margin-bottom min-w-1400" @click="toggleNewImage(12)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg12 ? yImgAct12 : yImg12" class="imgItem" />
      </div>
    </div>
  </div>
</template>

<script>
import importedImg1 from "@/page/starlightinfomation/components/img/3_1.png";
import y1 from "@/page/starlightinfomation/components/img/y1.png";
import y2 from "@/page/starlightinfomation/components/img/y2.png";
import y3 from "@/page/starlightinfomation/components/img/y3.png";
import y4 from "@/page/starlightinfomation/components/img/y4.png";
import y5 from "@/page/starlightinfomation/components/img/y5.png";
import y6 from "@/page/starlightinfomation/components/img/y6.png";
import y7 from "@/page/starlightinfomation/components/img/y7.png";
import y8 from "@/page/starlightinfomation/components/img/y8.png";
import y9 from "@/page/starlightinfomation/components/img/y9.png";
import y10 from "@/page/starlightinfomation/components/img/y10.png";
import y11 from "@/page/starlightinfomation/components/img/y11.png";
import y12 from "@/page/starlightinfomation/components/img/y12.png";

import yy1 from "@/page/starlightinfomation/components/img/yy1.png";
import yy2 from "@/page/starlightinfomation/components/img/yy2.png";
import yy3 from "@/page/starlightinfomation/components/img/yy3.png";
import yy4 from "@/page/starlightinfomation/components/img/yy4.png";
import yy5 from "@/page/starlightinfomation/components/img/yy5.png";
import yy6 from "@/page/starlightinfomation/components/img/yy6.png";
import yy7 from "@/page/starlightinfomation/components/img/yy7.png";
import yy8 from "@/page/starlightinfomation/components/img/yy8.png";
import yy9 from "@/page/starlightinfomation/components/img/yy9.png";
import yy10 from "@/page/starlightinfomation/components/img/yy10.png";
import yy11 from "@/page/starlightinfomation/components/img/yy11.png";
import yy12 from "@/page/starlightinfomation/components/img/yy12.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      yImg1 : y1,
      yImg2 : y2,
      yImg3 : y3,
      yImg4 : y4,
      yImg5 : y5,
      yImg6 : y6,
      yImg7 : y7,
      yImg8 : y8,
      yImg9 : y9,
      yImg10 : y10,
      yImg11 : y11,
      yImg12 : y12,
      yImgAct1 : yy1,
      yImgAct2 : yy2,
      yImgAct3 : yy3,
      yImgAct4 : yy4,
      yImgAct5 : yy5,
      yImgAct6 : yy6,
      yImgAct7 : yy7,
      yImgAct8 : yy8,
      yImgAct9 : yy9,
      yImgAct10 : yy10,
      yImgAct11 : yy11,
      yImgAct12 : yy12,
      isActimg1: false,
      isActimg2: false,
      isActimg3: false,
      isActimg4: false,
      isActimg5: false,
      isActimg6: false,
      isActimg7: false,
      isActimg8: false,
      isActimg9: false,
      isActimg10: false,
      isActimg11: false,
      isActimg12: false,
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    toggleNewImage(imageIndex) {
      if (imageIndex == 1) {
        this.isActimg1 = !this.isActimg1;
      }
      if (imageIndex == 2) {
        this.isActimg2 = !this.isActimg2;
      }
      if (imageIndex == 3) {
        this.isActimg3 = !this.isActimg3;
      }
      if (imageIndex == 4) {
        this.isActimg4 = !this.isActimg4;
      }
      if (imageIndex == 5) {
        this.isActimg5 = !this.isActimg5;
      }
      if (imageIndex == 6) {
        this.isActimg6 = !this.isActimg6;
      }
      if (imageIndex == 7) {
        this.isActimg7 = !this.isActimg7;
      }
      if (imageIndex == 8) {
        this.isActimg8 = !this.isActimg8;
      }
      if (imageIndex == 9) {
        this.isActimg9 = !this.isActimg9;
      }
      if (imageIndex == 10) {
        this.isActimg10 = !this.isActimg10;
      }
      if (imageIndex == 11) {
        this.isActimg11 = !this.isActimg11;
      }
      if (imageIndex == 12) {
        this.isActimg12 = !this.isActimg12;
      }
    },
  },
};
</script>

<style scoped>
  .max-w-1400{
    max-width: 1620px !important;
}
.min-w-1400{
    min-width: 1400px !important;
}
.contentBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.imgBox1,
.priBox{
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.imgBox1 {
  margin-bottom: 100px;
}

.img1Box,
.imgBox {
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}

.imgItem{
  width: 100%;
  margin: 0;
}

.priBox{
  cursor: pointer;
  margin-bottom: 40px;
  padding: 0px 200px;
}

.margin-bottom{
  margin-bottom: 80px;
}
</style>
